import { useState } from "react";

import { ContentProps } from "../Content";
import { MaxWidthContainer } from "../style";
import CreatePoll from "./CreatePoll";
import PollPreview from "./PollPreview";
import { ArticleProps } from "../../../../../redux/slices/article/Article";
import { useFindContent } from "../../useFindContent";

const Poll = ({ id }: ContentProps.CommonProps) => {
  const { content_data } = useFindContent(id) as ArticleProps.WithPollContent;
  const pollOptions = [
    content_data.choice_1,
    content_data.choice_2,
    content_data.choice_3,
    content_data.choice_4,
    content_data.choice_5,
    content_data.choice_6,
    content_data.choice_7,
    content_data.choice_8,
    content_data.choice_9,
    content_data.choice_10,
  ].filter((option) => option);

  const [isPollCreated, setIsPollCreated] = useState(
    pollOptions.length >= 3 && content_data.question ? true : false
  );
  return (
    <MaxWidthContainer>
      {isPollCreated ? (
        <PollPreview
          id={id}
          setIsPollCreated={setIsPollCreated}
          pollOptions={pollOptions}
        />
      ) : (
        <CreatePoll
          id={id}
          setIsPollCreated={setIsPollCreated}
          pollOptions={pollOptions}
        />
      )}
    </MaxWidthContainer>
  );
};

export default Poll;
